export const app = {
  title: 'AI Language Assistant',
  subtitle: 'Smart Language Learning',
  signin: 'Sign In',
  signout: 'Sign Out'
};